import { rem } from 'polished';
import styled from 'styled-components';

export const StyledContainer = styled.div`
  display: flex;
  padding: 0;
  flex-direction: column;
  font-size: 12px;
  @media only screen and (min-width: 768px) {
    font-size: 14px;
  }
  @media only screen and (min-width: 1280px) {
    font-size: ${rem('16px')};
  }
`;
